import { useLocalizationStore } from "../../api/Zustand";

export function getLanguageFile(key: string) {
  const { languageFile } = useLocalizationStore.getState();

  if (languageFile && languageFile[key]) return languageFile[key];
  else return key;
}
